<div class="custom-object-card">
  <!-- More Menu Button -->
  <span *ngIf="showActions" class="more-button ui-icon-more-menu" [matMenuTriggerFor]="menu"  (click)="$event.stopPropagation()">
  </span>

  <!-- Dropdown Menu -->
  <mat-menu #menu="matMenu" xPosition="before" class="custom-object-menu">
    <button mat-menu-item (click)="onEditName()">
      {{ 'CUSTOM_OBJECTS.MENU.EDIT_NAME' | translate }}
    </button>
<!--    <button mat-menu-item (click)="onRetrain()">-->
<!--      {{ 'CUSTOM_OBJECTS.MENU.RETRAIN' | translate }}-->
<!--    </button>-->
    <button mat-menu-item (click)="onRemove()">
      {{ 'CUSTOM_OBJECTS.MENU.REMOVE' | translate }}
    </button>
  </mat-menu>

  <!-- Image Container -->
  <div class="card-image-container" [class.state-container]="isStateCustomObject(customObject)">
    <ng-container *ngIf="isStateCustomObject(customObject); else standardImage">
      <div class="state-preview-circle" 
           [class.count-2]="statePreviewCount === 2" 
           [class.count-3]="statePreviewCount === 3" 
           [class.count-4]="statePreviewCount >= 4">
        <div
          class="state-preview-bubble"
          *ngFor="let stateItem of statePreviewItems; let i = index; trackBy: trackByIndex"
          [class.count-2]="statePreviewCount === 2"
          [class.count-3]="statePreviewCount === 3"
          [class.count-4]="statePreviewCount >= 4"
          [class.index-0]="i === 0"
          [class.index-1]="i === 1"
          [class.index-2]="i === 2"
          [class.index-3]="i === 3">
          <img
            *ngIf="stateItem.url && !stateItem.hasError"
            [appAuthSrc]="stateItem.url"
            [alt]="stateItem.label"
            class="state-preview-image"
            (authError)="onStateImageError(i)" />
          <div *ngIf="!stateItem.url || stateItem.hasError" class="state-preview-placeholder"></div>
          <div class="state-preview-label">{{ stateItem.label }}</div>
        </div>
      </div>
    </ng-container>
    <ng-template #standardImage>
      <img *ngIf="getImagePath() && !imageLoadError" 
           [appAuthSrc]="getImagePath()"
           [alt]="getDisplayName()"
           class="card-image"
           (authError)="onImageError()" />
      <img *ngIf="!getImagePath() || imageLoadError" 
           src="assets/icons/custom-object-minimal.svg"
           alt="Custom object placeholder"
           class="placeholder-icon" />
    </ng-template>
  </div>

  <!-- Title -->
  <div class="card-title" [title]="getDisplayName()">
    {{ getDisplayName() }}
  </div>

  <!-- Tags -->
  <div class="card-tags" *ngIf="getDisplayTags().length > 0">
    <div class="tag" *ngFor="let tag of getDisplayTags()">
      {{ tag | translate }}
    </div>
  </div>
</div>
